<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Root',
  computed: {
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  created() {
    if (this.signedInUser) {
      this.$router.push({ name: 'mySpace'})
    } else {
      this.$router.push({ name: 'service'})
    }
  }
}
</script>
